import React, { ReactNode } from 'react';
import { Info } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

export type InfoTextProps = {
    label: ReactNode;
    variant?: Variant;
    paddingTop?: number;
};

const InfoText = ({ label, ...rest }: InfoTextProps) => {
    return (
        <Stack direction="row" alignItems="top" spacing={2} marginTop={2} marginBottom={3}>
            <Info color="primary" />
            <Typography {...rest} style={{ whiteSpace: 'pre-line' }}>
                {label}
            </Typography>
        </Stack>
    );
};

export default InfoText;
